<div class="billing-new-details-main">
    <div class="row">
        <!-- <div class="col no-padding-right no-padding-top">
          <mapfre-button
            additionalClasses="link-button red-link top-information no-padding button-border-red font-weight-500"
            [backIcon]="'assets/img/icons/back-arrow-red.png'"
            [iconClasses]="'align-middle pr-1'"
            [showIconsCustom]="true"
            (click)="navigateBack()"
          >  {{ 'BACK' | translate }}
          </mapfre-button>
        </div> -->
        <div class="col no-padding-right no-padding-top">
            <ng-container *ngIf="isAcmic; else maStateBackbtn">
                <mapfre-button
                    additionalClasses="link-button blue-color-link top-information no-padding font-weight-normal"
                    [backIcon]="'assets/img/icons/back-arrow-blue.svg'" [iconClasses]="'align-middle pr-1'"
                    [showIconsCustom]="true" routerLink="/billing-new/billing-landing"> {{ 'Back' | translate }}
                </mapfre-button>
            </ng-container>
            <ng-template #maStateBackbtn>
          <mapfre-button
            additionalClasses="link-button red-link top-information no-padding button-border-red font-weight-500"
            [backIcon]="'assets/img/icons/back-arrow-red.png'"
            [iconClasses]="'align-middle pr-1'"
            [showIconsCustom]="true"
            routerLink="/billing-new/billing-landing"
          >  {{ 'BACK' | translate }}
          </mapfre-button>
          </ng-template>
        </div>
    </div>
    <div class="billing-new-header">
        <div class="bn-back-action">

        </div>
        <div class="w-100" *ngIf="billingPolicyData?.policyData?.length">
            <app-billing-details-header [billingPolicyData]="billingPolicyData" (selectPolicy)="onPolicySelect($event)"></app-billing-details-header>
        </div>    
    </div>
    <div class="billing-navs">
        <nav class="billing-details-nav">
            <a 
                routerLinkActive="active" 
                
                class="billing-nav-tab overview" routerLink="/billing-new/{{ policyNumber }}/details"
                title="{{ 'BILLING' | translate }}">{{ "Overview" | translate }}</a>
            <a class="billing-nav-tab" routerLinkActive="active" routerLink="/billing-new/{{ policyNumber }}/make-a-payment"
                title="{{ 'POLICY_OVERVIEW' | translate }}">{{ "Make a payment" | translate }}</a>
            <a class="billing-nav-tab {{activeClass}} document" routerLinkActive="active" routerLink="/billing-new/{{ policyNumber }}/documents"
                title="{{ 'DOCUMENTS' | translate }}">{{ "DOCUMENTS" | translate }}</a>
        </nav>
        <div class="empty-nav-div"></div>
    </div>
    <div class="bn-inner-section">
        <div class="w-100">
            <ng-container *ngIf="policy">                
                <app-bn-tab-header [policy]="policy"></app-bn-tab-header>    
                <section id="lastInvoice">         
                    <app-bn-document-details></app-bn-document-details>
                </section>
            </ng-container>
            <app-billing-assistance-cards [company]="company" [policyNumber]="policyNumber" [isAcmic]="isAcmic"></app-billing-assistance-cards>
        </div>
    </div>
</div>